// extracted by mini-css-extract-plugin
export default {"grid":"TrustedFeatures_grid__vkqBz","trustedFeatures":"TrustedFeatures_trustedFeatures__YOWxK","item":"TrustedFeatures_item__AiY+l"};